/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useLayoutEffect, useState } from 'react'
import debounce from 'lodash/debounce'

const useIsTablet = () => {
  const [isTablet, setIsTablet] = useState(false)

  useLayoutEffect(() => {
    const updateSize = () => {
      setIsTablet(window?.innerWidth >= 768 && window?.innerWidth < 992)
    }
    updateSize()
    window?.addEventListener('resize', debounce(updateSize, 250))
    return () => { window?.removeEventListener('resize', updateSize) }
  }, [])
  return isTablet
}

export default useIsTablet
